// Copyright (c) Move Closer 2022.

import { ValidationRules } from '../../../shared/molecules/Form'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const customerDetailsValidatorsMap: ValidationRules = {
  address: 'required|string|min:4',
  billingAddress: 'required_if:sameBillingAddress,false|string|min:4',
  billingCity: 'required_if:sameBillingAddress,false|string|min:2',
  // billingPostalCode: 'required_if:sameBillingAddress,false|string|min:5|max:7',
  billingPostalCode: 'string|min:5|max:7|nullable',
  city: 'required|string|min:2',
  company: 'filled|string|min:2',
  country: 'required|string|min:2',
  email: 'required|email',
  firstName: 'required|string|min:3',
  hasInvoice: 'boolean',
  invoiceCompany: 'required_if:hasInvoice,true|string|min:2',
  invoiceNip: 'required_if:hasInvoice,true|string|min:10|max:10',
  isSignupRequested: 'boolean',
  lastName: 'required|string|min:2',
  password: 'required_if:isSignupRequested,true|string|min:6|confirmed',
  passwordConfirmation: 'nullable',
  phone: 'required|string|min:9',
  // postalCode: 'filled|string|min:5|max:7',
  postalCode: 'string|min:5|max:7|nullable',
  sameBillingAddress: 'boolean'
}
